export default __webpack_public_path__ + "static/media/ooopener.fb6f3b3a.svg";